<template>
  <!-- Dashboard Box -->
  <div class="col-xl-12">
    <div id="test1" class="dashboard-box">
      <!-- Headline -->
      <div class="headline">
        <h3>
          <i class="icon-material-outline-lock"></i>
          User Skills
        </h3>
      </div>

      <div class="content with-padding padding-bottom-10">
        <div class="row">
          <div class="col-xl-12">
            <div class="submit-field">
              <h5>
                Skills
                <i
                  class="help-icon"
                  data-tippy-placement="right"
                  title="Add up to 10 skills"
                ></i>
              </h5>

              <!-- Skills List -->
              <div class="keywords-container">
                <div class="keyword-input-container">
                  <input
                    type="text"
                    class="keyword-input with-border"
                    placeholder="e.g. Plumbing, Gardening"
                    v-model="userSkill"
                    @keyup="autocomplete($event.target.value)"
                  />
                  <div id="" class="autocomplete-items" v-if="userSkill !== ''">
                    <div
                      v-for="task in filteredTasks"
                      :key="task.id"
                      @click="addSkill(task)"
                    >
                      <strong>{{ task.name }}</strong>
                      <input type="hidden" :value="task.name" />
                    </div>
                  </div>
                </div>
                <div class="keywords-list">
                  <span
                    class="keyword"
                    v-for="(skill, index) in userSkills"
                    :key="index"
                    @click="removeSkill(index)"
                    ><span class="keyword-remove "></span
                    ><span class="keyword-text">{{ skill.name }}</span></span
                  >
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>

          <div class="col-xl-12">
            <a
              href="#"
              class="button ripple-effect big  "
              @click="updateUserSkills()"
              ><i class="icon-material-outline-lock mr-1"></i>
              Update User Skills
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import {
  UPDATE_USER_SKILL,
  GET_MY_SKILLS,
} from "../../../core/config/endpoints/user";
import { ALL_SUBTASKS } from "../../../core/config/endpoints/tasks";
import { postCall, getCall } from "../../../core/services/http.service";

export default {
  name: "UpdateUserSkill",
  data() {
    return {
      userSkill: "",
      userSkills: [],
      allTasks: [],
      isUserTyping: true,
      filteredTasks: [],
      userSkillIds: {
        skillsIds: [],
      },
    };
  },
  mounted() {
    this.getUserSkills();
  },
  created() {
    this.getAllSubTasks();
  },
  methods: {
    updateUserSkills() {
      this.storeUserSkillIds();

      postCall(UPDATE_USER_SKILL, this.userSkillIds.skillsIds)
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    getUserSkills() {
      getCall(GET_MY_SKILLS)
        .then(response => {
          this.userSkills = response.data.data;
          this.storeUserSkillIds();
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    removeSkill(skillIndex) {
      this.userSkills = this.userSkills.filter(
        skill => skill.id !== skillIndex
      );
    },
    getAllSubTasks() {
      this.$store.commit("setIsLoaded", true);
      getCall(ALL_SUBTASKS)
        .then(response => {
          this.allTasks = response.data.data.data;
          this.filteredTasks = response.data.data.data;
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    autocomplete() {
      let allTasks = this.allTasks;
      let numberOfSkills = allTasks.length;
      let skillValue = this.userSkill.toUpperCase();

      if (skillValue === "" || numberOfSkills === 0) {
        return false;
      }

      allTasks.forEach(() => {
        this.filteredTasks = allTasks.filter(task => {
          if (task.name.toUpperCase().indexOf(skillValue) !== -1) {
            return true;
          }
          return false;
        });
      });
    },
    addSkill(skill) {
      if (this.userSkillIds.skillsIds.includes(skill.id)) {
        this.userSkill = "";
        this.$toast.error(`The '${skill.name}' skill has already been added`);
        return false;
      }
      this.userSkills.push({ id: skill.id, name: skill.name });
      this.userSkillIds.skillsIds.push(skill.id);
      this.userSkill = "";
    },
    storeUserSkillIds() {
      this.userSkills.forEach(skill => {
        if (!this.userSkillIds.skillsIds.includes(skill.id)) {
          this.userSkillIds.skillsIds.push(skill.id);
        }
      });
    },
  },
};
</script>

<style scoped></style>
